import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from "axios";
import VueAxios from "vue-axios";
import {VueReCaptcha} from "vue-recaptcha-v3";


// axios.defaults.baseURL = "https://help-api.tradedepot.co.nz/api/v1/"
// axios.defaults.baseURL = "https://help-api.tradedepottest.com/api/v1/"
// axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
createApp(App).use(router).use(VueAxios,axios).use(VueReCaptcha, {siteKey:"6Le9GAggAAAAAHX6W0apZqcAD5RioOVIR3vzYD3V"}).mount('#app')
